// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e73b1636","355":"3366f505"}[chunkId] + ".chunk.js";
};